import FormattedMessage from 'I18n/components/FormattedMessage';
import UIRadioInput from 'UIComponents/input/UIRadioInput';
import UIFlex from 'UIComponents/layout/UIFlex';
import UILink from 'UIComponents/link/UILink';
import { MEETINGS_LINK_TYPES as LINK_TYPES } from 'hubspot-prosemirror/draft-transplant/utils/constants';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const MeetingsLinkSelectionRadio = ({
  linkType,
  selectedLink,
  radioName,
  handleRadioChange,
  allowSenderMeetingLink
}) => {
  const isSelected = linkType === LINK_TYPES.CUSTOM;
  return /*#__PURE__*/_jsxs(UIFlex, {
    align: "center",
    children: [allowSenderMeetingLink && /*#__PURE__*/_jsx(UIRadioInput, {
      name: radioName,
      checked: isSelected,
      onChange: () => handleRadioChange(LINK_TYPES.CUSTOM),
      className: "p-all-0",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "hubspot-prosemirror.meetings.custommeetingslink"
      })
    }), /*#__PURE__*/_jsx(UILink, {
      href: selectedLink,
      external: true,
      className: "m-left-auto",
      disabled: !isSelected,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "hubspot-prosemirror.meetings.previewBookingPage"
      })
    })]
  });
};
export default MeetingsLinkSelectionRadio;